import React from 'react';
import TrustedSlider from './TrustedSlider';
import VideoSlider from './VideoSlider';

const Trusted = () => {
  return (
    <div className="bg-[#F5F5F5] relative overflow-hidden">
      <div className="absolute z-1 inset-0 lg:grid grid-cols-2 hidden">
        <div></div>
        <div className="relative flex h-full">
          <img className="absolute left-[-35px] h-full" src="/images/seo/trusted-bg.png" alt="trusted-bg" />
          <div className="absolute right-0 top-0 bottom-0 w-1/2 bg-[#EAE4EC]"></div>
        </div>
      </div>
      <div className="container py-[48px] relative">
        <div className="relative z-2 ml-auto pl-[20px] flex lg:flex-row flex-col gap-[70px] w-full">
          <TrustedSlider />
          <VideoSlider />
        </div>
      </div>
    </div>
  );
};

export default Trusted;
